import * as React from 'react'
import injectSheet from 'react-jss'
import {WithClasses} from './Helper'
import {singleColors} from '../Style'

const styles = {
    root: {
        width: '100%',
        display: 'flex',
        flexFlow: 'row',
        alignItems: 'center',
        padding: '16px 48px',
        borderTop: 'solid 1px',
        borderTopColor: singleColors.gray,
        fontSize: '14px',
        color: singleColors.labelColor,
        backgroundColor: '#fff',
        boxSizing: 'border-box'
    }
}

interface Properties {
    readonly children: React.ReactNode
}

export const Footer =
    injectSheet<Properties>(styles)(
        ({classes, children}: WithClasses<Properties>) => (
            <div
                className={classes.root}
            >
                {children}
            </div>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/Footer.tsx